<template>
  <main
    :class="['game-detail-gameTurbo', gameName]"
    :style="pageBackgroundColor"
  >
    <GameTurboHeader ref="header" />
    <main class="detail-content" :class="browser">
      <GameCodeHeaderTips />
      <DetailsUidComponent />
      <NEWPackTemplate />
      <NEWReinforcePayment />
    </main>
    <NEWSubmitBtn />
    <ActivityNotice />
    <CouponEntryForNotLogged :page="gameName" />
    <FissionPopup v-if="!isGetapps" :page="gameName" />
    <RankingPopup :gameName="gameName" />
  </main>
</template>
<script>
  import NEWSubmitBtn from '../components/NEWSubmitBtn'
  import ActivityNotice from '../components/ActivityNotice'
  import GameCodeHeaderTips from '../components/GameCodeHeaderTips'
  import CouponEntryForNotLogged from '@/components/CouponEntryForNotLogged'
  import FissionPopup from '@/pages/Activity/Fission/Popups'
  import RankingPopup from '@/pages/Activity/Ranking/Home/popup'
  import NEWReinforcePayment from '../components/NEWReinforcePayment'
  import NEWPackTemplate from '@/components/NEWPackTemplate'
  import DetailsUidComponent from '@/components/DetailsUidComponent'
  import { GameTurboHeader } from '../components/header'
  import { storage, isFromGameTurboKey } from '@/utils/storage'
  import { mapState } from 'vuex'
  import { getBrowserType, jumpToPage } from '@/utils/utils'

  export default {
    name: 'gameturbo', // game turbo端游戏详情页
    components: {
      GameTurboHeader,
      // IdSection,
      // PackageList,
      // SubmitBtn,
      NEWSubmitBtn,
      // LordsmobileTips,
      ActivityNotice,
      GameCodeHeaderTips,
      CouponEntryForNotLogged,
      // IdCheck,
      FissionPopup,
      RankingPopup,
      // MBPopover,
      // SkuTipsPopover,
      // ReinforcePayment,
      NEWReinforcePayment,
      NEWPackTemplate,
      DetailsUidComponent,
    },
    data() {
      return {}
    },
    computed: {
      ...mapState(['gameName', 'isGetapps']),
      // 页面背景颜色
      pageBackgroundColor() {
        const backgroundColor = this.$__GAME__?.pageBackgroundColor || ''

        return {
          backgroundColor,
        }
      },
      browser() {
        return getBrowserType(this.isMiuiBrowser, this.isChromeBrowser)
      },
    },
    created() {
      if (!process.client) return
      this.init()
    },
    methods: {
      init() {
        // Game Turbo 不提示添加 PWA
        window.addEventListener('beforeinstallprompt', function (e) {
          window.console.log('prevented PWA install prompt')
          e.preventDefault()
          return false
        })
        // Game Turbo 切换大窗时，取消全屏（因为浏览器有 bug，会挡住固定在底部的价格栏）
        // Game Turbo 下如果触发 resize 事件，说明用户切换到了大窗
        const callback = (e) => {
          e.target.removeEventListener('resize', callback) // 只触发一次
          // 添加到本地存储，页面刷新之后再打点
          storage.set(isFromGameTurboKey, 'true')
          if (window.location.href.indexOf('#') !== -1) {
            // 退出全屏，并切换到正常移动版页面
            jumpToPage(
              window.location.href
                .split('#')[0]
                .replace('mode=gt&', '')
                .replace('&mode=gt', '')
            )
          }
        }
        window.addEventListener('resize', callback)
      },
    },
  }
</script>

<style scoped lang="scss" src="./index_gt.scss"></style>
